if (!customElements.get('collection-hero')) {
  class CollectionHero extends HTMLElement {
    constructor() {
      super()

      this.siteHeader = document.getElementById('shopify-section-header')
      this.collectionSentinel = document.querySelector('[data-collection-sentinel]')
      this.collectionContent = document.querySelector('[data-collection-content]')
      this.stickyClass = 'collection-hero--is-sticky'

      // Observe intersections
      this.observe()
    }

    observe() {
      const headerRect = this.siteHeader.getBoundingClientRect()
      const headerToRootMargin = `-${headerRect.height}px 0px 0px 0px`

      // Instantiate observer
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.intersectionRatio === 0) {
            this.triggerStickyStyle(true)
          } else if (entry.intersectionRatio === 1) {
            this.triggerStickyStyle(false)
          }
        },
        {
          rootMargin: headerToRootMargin,
          threshold: [0, 1],
        },
      )

      // Observe
      observer.observe(this.collectionSentinel)
    }

    triggerStickyStyle(isSticky = false) {
      const headerRect = this.siteHeader.getBoundingClientRect()
      const headerHeight = `${headerRect.height - 1}px`

      const heroRect = this.siteHeader.getBoundingClientRect()
      const heroHeight = `${heroRect.height - 2}px`

      if (isSticky) {
        this.classList.add(this.stickyClass)
        this.style.top = headerHeight
        this.collectionContent.style.paddingTop = heroHeight
      } else {
        this.classList.remove(this.stickyClass)
        this.style.top = 0
        this.collectionContent.style.paddingTop = 0
      }
    }
  }

  window.CollectionHero = CollectionHero
  customElements.define('collection-hero', CollectionHero)
}
